import React from 'react';
import styles from './footer-xsci.module.css'
// import responsive from "./footer-xsci-responsive.module.css";
// import {useTranslation} from "react-i18next";
import CompanySection from "./company-section";
import ContactSection from "./contact-section";
import ServicesSection from "./services-section";

const FooterComponent = () => {
    // const {t, i18n} = useTranslation();


    return (
        <div className="container-fluid justify-content-center">
            <hr className="mx-0 px-0"/>
            <footer>
                <div className="row justify-content-around mb-0 pt-5 pb-0 ">
                    <div className=" col-11">
                        <div className="row justify-content-center">
                            <div className="col-md-3 col-12 font-italic align-items-center  mt-md-3 mt-4">
                                <a className={`navbar-brand d-flex align-items-center ${styles.logo}`} href="/">
                                    <img
                                        src="/logo512.png"
                                        alt="Logo placeholder"
                                        style={{
                                            width: 80,
                                            height: 80,
                                            marginRight: 10,
                                            borderRadius: '5px',
                                            objectFit: 'cover'
                                        }}
                                    />
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        lineHeight: '1',
                                        color: "#113265"
                                    }}>
                                        <span style={{fontFamily: "K2D !important!", color:"royalblue"}}>VICE</span>
                                        <span
                                            style={{fontFamily: "'Cookie', cursive !important", fontSize: "34px", color:"royalblue" }}>AQUATICS</span>
                                    </div>
                                </a>
                                <p className={`mt-md-3 mt-2 ${styles.social}`}>
                                    {/*<span>*/}
                                    {/*    <a href="https://www.facebook.com/people/XSCI/61573466566374/"*/}
                                    {/*        // className={`${styles.follow_us_link} ${responsive.follow_us_link}`}*/}
                                    {/*       target="_blank"*/}
                                    {/*       rel="noopener noreferrer">*/}
                                    {/*            <FontAwesomeIcon icon={faFacebook}*/}
                                    {/*                             style={{*/}
                                    {/*                                 cursor: 'pointer',*/}
                                    {/*                                 fontSize: '21px',*/}
                                    {/*                                 margin: '5px 10px 5px 10px',*/}
                                    {/*                                 color: "black"*/}
                                    {/*                             }}/>*/}
                                    {/*    </a>*/}
                                    {/*</span>*/}
                                    <span>
                                        {/*<a href="https://instagram.com/xscisolutions"*/}
                                        {/*   target="_blank"*/}
                                        {/*   rel="noopener noreferrer">*/}
                                        {/*        <FontAwesomeIcon icon={faInstagram}*/}
                                        {/*                         style={{*/}
                                        {/*                             cursor: 'pointer',*/}
                                        {/*                             fontSize: '42px',*/}
                                        {/*                             margin: '5px 10px 5px 10px',*/}
                                        {/*                             color: "black"*/}
                                        {/*                         }}/>*/}
                                        {/*</a>*/}
                                        <a href="https://www.instagram.com/vice.aquatics/" target="_blank"
                                           rel="noopener noreferrer">
                                               <img
                                                   src="/images/instagram.svg"
                                                   alt=""
                                                   style={{width: "40px", cursor: "pointer"}}
                                               />
                                        </a>
                                    </span>
                                </p>
                                <small className="copy-rights cursor-pointer" style={{color: "#C0C0C0"}}>&#9400;{new Date().getFullYear()}
                                    &nbsp; Vice Aquatics
                                </small><br/>
                                <small  style={{color: "#C0C0C0"}}>
                                    Copyright. All Rights Reserved. DESIGNED AND MANAGED BY{" "}
                                    <a href="https://xsci.ca" target="_blank" rel="noopener noreferrer"
                                       style={{color: "#C0C0C0"}}>
                                        XSCI
                                    </a>
                                </small>
                            </div>
                            <CompanySection/>
                            <ServicesSection/>
                            <ContactSection/>

                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default FooterComponent;